const DEFAULT_MODEL = 'google/gemini-3.8-flash';

const MODELS = [
  'openai/gpt-5.6-luna',
  'google/gemini-3.8-flash'
];

const TAG_RESPONSES_SYSTEM_PROMPT = 'You are analyzing responses to a survey question and your task is to tag the responses.';
const SUGGEST_TAGS_SYSTEM_PROMPT = 'You are analyzing responses to a survey question and your task is to suggest tags for the responses.';
const SUMMARIZE_RESPONSES_SYSTEM_PROMPT = 'You are summarizing free-text answers to a survey question. Write a concise, structured summary of the main themes and notable points, using short Markdown lists and bold topic labels to make it easy to scan. Avoid long blocks of text. Include verified counts for individual topics where useful, but do not repeat the overall response count already shown in the interface. Do not invent quotes, counts, or claims that are not supported by the answers. Do not include personal data.';

module.exports = {
  DEFAULT_MODEL,
  MODELS,
  TAG_RESPONSES_SYSTEM_PROMPT,
  SUGGEST_TAGS_SYSTEM_PROMPT,
  SUMMARIZE_RESPONSES_SYSTEM_PROMPT,
};
